import { useEffect, useState } from "react";
import api from "../components/api";
import { useQuery, useMutation } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import toast from 'react-hot-toast'

type iCorretorBusca = {

    id: number,
    descricao: string,

}

type iDadosCorretor = {

    cliente_id: number,
    tomador_id: number,
    corretor_id: number,
    usuario_id: number,

}

type iCorretoresTomadores = {

    corretor_id: number,
    cpf: string,
    cnpj: string,
    nome: string,
    nomeFantasia: string,
    razaoSocial: string,
    exibicao: string,
    tomadorCorretor_id: number,


}


export default function TomadorCorretores(props: any) {

    const { cliente_id, usuario_id, tomador_id } = props

    const [resultadoCorretor, setResultadoCorretor] = useState<React.ReactNode>()
    const [corretor_id, setCorretor_id] = useState<number | undefined>()
    const [corretor, setCorretor] = useState<string | undefined>('')



    const { data, isLoading } = useQuery({

        queryKey: ['buscaCorretor', cliente_id, corretor],
        queryFn: async () => {

            try {

                const dataPost = {

                    cliente_id,
                    descricao: corretor,

                }

                const result = await api.post<iCorretorBusca[]>('corretorBusca', dataPost)
                return result.data ?? []

            } catch (err: any) {

                console.log(err.response)
                throw err

            }


        },
        enabled: !!corretor && corretor.length >= 3

    })


    const { mutate: adicionaCorretor } = useMutation({

        mutationKey: ['adicionaCorretor', cliente_id],
        mutationFn: async (data: iDadosCorretor) => {


            var dataPost = {

                cliente_id: data.cliente_id,
                corretor_id: data.corretor_id,
                ad_usr: data.usuario_id,
                tomador_id: data.tomador_id,

            }

            const result = await api.post('tomadorCorretor', dataPost)
            return result.data ?? {}

        },
        onSuccess: (data: any) => {

            setResultadoCorretor('')

            if (data.status == 'ok') {

                refetch()
                setCorretor('')
                toast.success('Registro salvo com sucesso!')

            }

        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }


    })


    useEffect(() => {

        if (data) {


            setResultadoCorretor(data.map((rs: iCorretorBusca) =>

                <Link to='#' onClick={() => adicionaCorretor({

                    corretor_id: rs.id,
                    tomador_id,
                    cliente_id,
                    usuario_id,

                })}><span style={{ color: 'red' }}>[</span>{rs.descricao}<span style={{ color: 'red' }}>]</span>&nbsp;</Link>


            ))


        }

    }, [data])


    const { data: corretoresTabela, refetch } = useQuery({

        queryKey: ['corretoresTomadores', cliente_id, tomador_id],
        queryFn: async () => {

            try {

                var dataPost = {

                    cliente_id,
                    tomador_id,

                }

                const result = await api.post<iCorretoresTomadores[]>('tomadorCorretorListaTodos', dataPost)
                return result.data ?? []

            } catch (err: any) {

                console.log(err.response)
                throw err

            }

        },

        enabled: !!tomador_id,

    })


    useEffect(() => {


        props.setTotalCorretores(corretoresTabela?.length ?? 0)


    }, [corretoresTabela])



    const { mutate: apagaCorretor } = useMutation({

        mutationKey: ['apagaCorretor'],
        mutationFn: async (tomadorCorretor_id: number) => {

            const result = await api.delete(`tomadorCorretor/${tomadorCorretor_id}`, { data: { cliente_id } })
            return result.data ?? {}

        },
        onSuccess: (data: any) => {

            if (data.status == 'ok') {

                toast.success('Registro apagado com sucesso!')
                refetch()

            }

        },
        onError: (err: any) => {

            console.log(err.response)
            throw err

        }

    })


    return (

        <div>

            <form className="row g-3">

            <div className="col-md-12">

                <input type="text"
                    className="form-control"
                    value={corretor}
                    onChange={event => setCorretor(event.target.value)} onFocus={() => { setCorretor(''); setResultadoCorretor(''); setCorretor_id(undefined) }}
                    placeholder="Busque o corretor para vinculação (mínimo 3 caracteres)"
                />
                {resultadoCorretor}
            </div>
            <div className="col-md-12">
                <fieldset className="form-group">


                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', backgroundColor: '#EFEFEF' }}>



                                </th>

                                <th style={{ fontSize: '11px', backgroundColor: '#EFEFEF', textAlign: 'right' }}>

                                    &nbsp;

                                </th>

                            </tr>

                        </thead>
                        <tbody>

                            {
                                corretoresTabela?.map((rs: iCorretoresTomadores) =>


                                    <tr>
                                        <td>
                                            {rs.exibicao}
                                        </td>
                                        <td style={{ cursor: 'pointer' }} onClick={() => apagaCorretor(rs.tomadorCorretor_id)}>
                                            <span style={{ color: 'orange' }} >[Apagar]</span>
                                        </td>
                                    </tr>


                                )
                            }

                        </tbody>

                    </table>



                </fieldset>
            </div>



            </form>

        </div>

    )


}
